import React from 'react';
import PropTypes from 'constants/PropTypes';
import kebabCase from 'lodash/kebabCase';
import commonPropTypes from './commonPropTypes';
import FormGroup from '../FormGroup';
import FormLabel from '../FormLabel';
import InformationPopover from '../../InformationPopover';
import Instructions from '../Instructions';

const propTypes = {
    // REDUX FORM
    // eslint-disable-next-line react/forbid-prop-types
    input: PropTypes.any.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    meta: PropTypes.any.isRequired,
    className: PropTypes.string,
    ...commonPropTypes,
};

const defaultProps = {
    className: 'form-control',
};

class SimpleFieldComponent extends React.Component {
    renderInput() {
        const {
            componentType,
            input,
            meta,
            instructions,
            label,
            popover,
            showSuccessOnValid,
            ...extraProps
        } = this.props;
        const Component = componentType;

        if (typeof Component === 'function') {
            return <Component {...this.props} />;
        }

        return <Component {...input} {...extraProps} />;
    }

    renderLabel() {
        const {
            label,
            input: { name },
        } = this.props;
        return <FormLabel id={name}>{label}</FormLabel>;
    }

    renderError() {
        const { title, message } = this.props.meta.error;
        return <Instructions title={title} text={message} />;
    }

    renderInstructions() {
        const { title, text } = this.props.instructions;
        return <Instructions title={title} text={text} />;
    }

    renderInformationPopover() {
        const { popover, input } = this.props;
        return <InformationPopover information={popover} parentName={input.name} />;
    }

    render() {
        const { showSuccessOnValid, label, instructions, popover, input, meta } = this.props;
        const { name } = input;
        const { touched, invalid, error, active } = meta;

        const shouldRenderLabel = !!label;
        const shouldRenderPopover = !!popover;
        const shouldRenderError = touched && invalid && error.show && error.title;
        const shouldRenderInstructions = !!instructions && !shouldRenderError && active;

        return (
            <FormGroup
                className={`ofx-field ${name} ${kebabCase(`uia-${name}`)}`}
                error={invalid}
                touched={touched}
                showSuccessOnValid={showSuccessOnValid}
            >
                {shouldRenderLabel && this.renderLabel()}
                {shouldRenderPopover && this.renderInformationPopover()}
                {this.renderInput()}
                {shouldRenderError && this.renderError()}
                {shouldRenderInstructions && this.renderInstructions()}
            </FormGroup>
        );
    }
}

SimpleFieldComponent.propTypes = propTypes;
SimpleFieldComponent.defaultProps = defaultProps;

export default SimpleFieldComponent;
